__turbopack_context__.v({
  "chart": "AreaGraph-module-scss-module__Mq7BSa__chart",
  "label": "AreaGraph-module-scss-module__Mq7BSa__label",
  "output": "AreaGraph-module-scss-module__Mq7BSa__output",
});
